import React, { Suspense, useEffect } from "react"
import { RouteFallback } from "components/new-stuff/layout/RouteFallback"
import { App, Layout } from "antd"
import { useState } from "react"
import { useAuthStore } from "stores"
import { Outlet } from "react-router-dom"
import { SideNavigationBar } from "./SideNavigationBar"
import { TopNavigationBar } from "./TopNavigationBar"
import { isPadeDomain } from "utils/utils"
import Intercom from "@intercom/messenger-js-sdk"
import { NotificationBar } from "../employee/NotificationBar"
import useExtendUser from "hooks/useExtendUser"
import IdleTimer from "IdleTimer"
import HandholdHelp from "components/handhold/HandholdHelp"
import { WhatsNewPopup } from "features/whats-new/WhatsNewPopup"

const { Header, Content } = Layout

const NewResponsiveManagerLayout: React.FC = () => {
  const { user } = useAuthStore()
  const [isSidebarOpen, toggleSidebar] = useState(false)

  const { isAuthenticated, signOut } = useAuthStore((state) => ({
    isAuthenticated: state.isAuthenticated,
    signOut: state.signOut,
  }))

  useExtendUser()

  useEffect(() => {
    if (!isAuthenticated) {
      signOut(true)
    }
  }, [isAuthenticated])

  // if (user?.isManager !== true && user?.allowCrossReporting !== true) {
  //   return <Navigate to="/employee/dashboard" />
  // }

  isPadeDomain() === true &&
    Intercom({
      app_id: "bi604cch",
      user_id: user?.userId?.toString(),
      name: user?.userFullName,
      email: user?.userName,
    })

  return (
    <App
      notification={{
        placement: "topRight",
      }}
    >
      <IdleTimer />
      <WhatsNewPopup whatsNewPath="/manager/whats-new" />
      <HandholdHelp />
      <Layout>
        <SideNavigationBar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        <Layout>
          <Header className="bg-white p-0 sticky top-0 z-10 w-full border-b md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none h-[70px]">
            <TopNavigationBar
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
          </Header>
          <Content className=" ">
            <div className="bg-[#F3F5FB] min-h-[100dvh] md:pl-[var(--sidenav-w)] transition-[padding-left] duration-300 ease-in-out motion-reduce:transition-none font-avenir employee__layout">
              <Suspense fallback={<RouteFallback />}>
                <Outlet />
              </Suspense>
              {/* <Dashboard /> */}
            </div>
          </Content>
        </Layout>
      </Layout>

      <NotificationBar />
    </App>
  )
}

export default NewResponsiveManagerLayout

